import React, { Component } from "react";
import echarts from "echarts/lib/echarts";
// 引入柱状图（这里放你需要使用的echarts类型 很重要）
import 'echarts/lib/chart/pictorialBar';
import 'echarts/lib/chart/line';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { getPublishGraphData } from "../../../../actions";
import { connect } from "react-redux";
import Card from '../../../components/card/Card'

/**
 * 发布排行卡片组件
 */
class PublishRankings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            xcolumn: [],
            ynumber: [],
            myChart: null,
        }
        this.resize = this.resize.bind(this);
    }

    screenChange() {
        window.addEventListener('resize', this.resize);
    }

    resize() {
        this.state.myChart && this.state.myChart.resize();
    }

    componentDidMount() {
        this.screenChange();
        // 基于准备好的dom，初始化echarts实例
        this.setState({
            myChart: echarts.init(document.getElementById('publishRankings'))
        })

        //后台获取资源发布数据信息
        var para;
        getPublishGraphData(para, this.updatePublishGraphData.bind(this))

        setTimeout(() => this.resize(), 1)
    }

    componentWillUnmount() {
        //console.info("componentWillUnmount");
        window.removeEventListener('resize', this.resize);
        this.setState = (state, callback) => {
            return;
        }
    }

    updatePublishGraphData(dayPostCount) {
        let numbers = dayPostCount;
        this.setState({ ynumber: numbers })
    }
    componentWillReceiveProps(nextProps, nextContext) {
        setTimeout(() => this.resize(), 200)
    }

    render() {

        var textureImg = new Image();
        textureImg.src = 'images/left01.png';

        if (this.state.myChart) {
            this.state.myChart.setOption({
                backgroundColor: '#FFFFFF',
                height: 200,
                color: ['#FFBF00', '#00A854', '#0E77D1'],
                title: {
                    text: '单位：篇',
                    left: 28,
                    top: 23,
                    textStyle: {
                        fontSize: '12',
                        fontFamily: 'Microsoft YaHei',
                        color: '#9ea5bd'
                    }
                },
                // tooltip: {},
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        // type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                xAxis: {
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            fontFamily: 'MicrosoftYaHei',
                            color: '#9ea5bd',
                        },
                    },
                    axisLine: {
                        show: true, //隐藏坐标轴
                        lineStyle: {
                            color: '#f4f6fc',  //坐标轴的颜色
                        },
                    },
                    data: [
                        '网站',
                        '公众号',
                        '微博'
                    ],
                },
                grid: {
                    left: '35',
                    right: '35',
                    bottom: '0',
                    top: 100,
                    containLabel: true
                },
                yAxis: {
                    // splitLine: {show: true},
                    axisTick: { show: false },
                    axisLabel: {
                        textStyle: {
                            fontFamily: 'MicrosoftYaHei',
                            color: '#9ea5bd',
                        },
                    },
                    axisLine: {
                        show: true, //隐藏坐标轴
                        lineStyle: {
                            color: '#f4f6fc',  //坐标轴的颜色
                        },
                    },
                    splitLine: {
                        show: true,   // 网格线是否显示
                        //  改变样式
                        lineStyle: {
                            color: '#f4f6fc'   // 修改网格线颜色     
                        }
                    },
                },
                series: [{
                    name: '已发布',
                    type: 'bar',
                    symbol: 'triangle',
                    barGap: 1,
                    barWidth: 80,
                    data: [{
                        value: this.state.ynumber[0],

                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#80c8ff'
                                }, {
                                    offset: 1,
                                    color: '#799aed'
                                }]),
                            }
                        }, label: { color: '#FFBF00' }
                    }, {
                        value: this.state.ynumber[1],
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#aaffdb'
                                }, {
                                    offset: 1,
                                    color: '#6fe7b3'
                                }]),
                            }
                        }, label: { color: '#00A854' }
                    }, {
                        value: this.state.ynumber[2],
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#c7aaff'
                                }, {
                                    offset: 1,
                                    color: '#7c53c9'
                                }]),
                            }
                        }
                    }],
                    label: { distance: 20 }

                }],
            });
        }


        return (
            <Card title="发布排行" style={{ marginTop: 20 }}>
                <div id='publishRankings' style={{ height: '375px', }}></div>
            </Card>
        )
    }
}

const stateToProps = (state) => {
    return {
        config: state.systemReducer.config,
        navigateStatus: state.systemReducer.navigateStatus
    }
}

export default connect(stateToProps, null)(PublishRankings);
